const { body } = document;
const header = document.getElementById('header');
const scrollUp = 'body-scroll-up';
const scrollDown = 'body-scroll-down';
let lastScroll = 0;

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 180) {
    header.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    // up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});

const dropdownPos = () => {
  if (header && header.length) {
    const dropdowns = header.querySelectorAll(
      '.c-main-nav__dropdown--megamenu',
    );
    if (dropdowns.length) {
      dropdowns.forEach(dropdown => {
        dropdown.style.setProperty(
          '--dropdown-width',
          `${document.querySelector('.c-header').offsetWidth}px`,
        );
        dropdown.style.setProperty(
          '--dropdown-offset',
          `${dropdown.getBoundingClientRect().left}px`,
        );
      });
    }
  }
};

dropdownPos();
window.addEventListener('resize', dropdownPos);

const closeMenu = () => {
  const menuToggle = document.querySelector('.c-header__menu-toggle');
  const mobileScrollToElments = document.querySelectorAll(
    '.c-mobilenav__menu [data-slidemenu-close]',
  );

  mobileScrollToElments.forEach(elm => {
    if (menuToggle) {
      elm.addEventListener('click', () => {
        menuToggle.click();
      });
    }
  });
};

closeMenu();
